import { GameManager } from "./../../GameManager";
import { GameConstants } from "./../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { AudioManager } from "../../AudioManager";

export class SelectAvatarLayer extends Phaser.GameObjects.Container {

    private maleBtn: Phaser.GameObjects.Image;
    private femaleBtn: Phaser.GameObjects.Image;

    private avatarImg: Phaser.GameObjects.Image;
    private leftArrow: Button;
    private rightArrow: Button;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = 500;

        let selectAvatarText = new Phaser.GameObjects.Text(this.scene, -70, 0, GameVars.gameText.GAME[1], {fontFamily: "HelveticaNeue", fontSize: "45px", color: "#5E290E", align: "center"});
        selectAvatarText.setOrigin(.5);
        this.add(selectAvatarText);

        this.maleBtn = new Phaser.GameObjects.Image(this.scene, 130, 0, "texture_atlas_1", GameVars.gameData.genre === GameConstants.GENDER_MALE ? "male_symbol_on" : "male_symbol_off");
        this.maleBtn.setInteractive({pixelPerfect: false});
        this.maleBtn.on("pointerdown", this.onMaleDown, this);
        this.add(this.maleBtn);

        this.femaleBtn = new Phaser.GameObjects.Image(this.scene, 200, 0, "texture_atlas_1", GameVars.gameData.genre === GameConstants.GENDER_FEMALE ? "female_symbol_on" : "female_symbol_off");
        this.femaleBtn.setInteractive({pixelPerfect: false});
        this.femaleBtn.on("pointerdown", this.onFemaleDown, this);
        this.add(this.femaleBtn);

        let avatarFrame = new Phaser.GameObjects.Image(this.scene, 0, 150, "texture_atlas_1", "frame_avatar");
        this.add(avatarFrame);

        this.avatarImg = new Phaser.GameObjects.Image(this.scene, 0, 150, "texture_atlas_1", "avatar_" + GameVars.gameData.genre + "_" + GameVars.gameData.id);
        this.add(this.avatarImg);

        this.leftArrow = new Button(this.scene, -150, 150, "texture_atlas_1", "arrow", "arrow_hover");
        this.leftArrow.setScale(-1, 1);
        this.leftArrow.onDown(this.onLeftDown, this);
        this.add(this.leftArrow);

        this.rightArrow = new Button(this.scene, 150, 150, "texture_atlas_1", "arrow", "arrow_hover");
        this.rightArrow.onDown(this.onRightDown, this);
        this.add(this.rightArrow);
    }

    private onMaleDown(): void {

        AudioManager.playSound("click");

        GameVars.gameData.genre = GameConstants.GENDER_MALE;
        GameManager.writeGameData();

        this.maleBtn.setFrame("male_symbol_on");
        this.femaleBtn.setFrame("female_symbol_off");

        this.avatarImg.setFrame("avatar_" + GameVars.gameData.genre + "_" + GameVars.gameData.id);
    }

    private onFemaleDown(): void {

        AudioManager.playSound("click");

        GameVars.gameData.genre = GameConstants.GENDER_FEMALE;
        GameManager.writeGameData();

        this.maleBtn.setFrame("male_symbol_off");
        this.femaleBtn.setFrame("female_symbol_on");

        this.avatarImg.setFrame("avatar_" + GameVars.gameData.genre + "_" + GameVars.gameData.id);
    }

    private onLeftDown(): void {

        AudioManager.playSound("click");
        
        GameVars.gameData.id = GameVars.gameData.id === 1 ? 12 : GameVars.gameData.id - 1;
        GameManager.writeGameData();

        this.avatarImg.setFrame("avatar_" + GameVars.gameData.genre + "_" + GameVars.gameData.id);
    }

    private onRightDown(): void {

        AudioManager.playSound("click");
        
        GameVars.gameData.id = GameVars.gameData.id === 12 ? 1 : GameVars.gameData.id + 1;
        GameManager.writeGameData();

        this.avatarImg.setFrame("avatar_" + GameVars.gameData.genre + "_" + GameVars.gameData.id);
    }
}
